<div class="panel clickable short" [routerLink]="['asset', asset.asset_id]">
	<div class="heading flushright">
		<div [class]="itemHealth?.Foreground()">
			{{asset.asset_name}}
			@if (asset.asset_serial_number) {
				<span> ({{asset.asset_serial_number}})</span>
			}@if (asset.fleet_id === 0) {
				<span> - {{asset.organization_name}}</span>
			}
		</div>
		<app-health-status-indicator [item]="asset" style="padding-right: 2px"></app-health-status-indicator>
	</div>
	<div class="content flex">
		<div>
			<div><b>{{asset.alt_asset_term || brand.assetSingular}} Type:</b> {{asset.asset_type_name | removeBaseline}}</div>
			@if (!asset.is_fixed && asset.flight_time !== null) {
				<div><b>{{brand.flightTime}}:</b> {{asset.flight_time | runtime}}</div>
			}
			@if (asset.rulmin) {
				<div><b>RUL:</b> {{asset.rulmin | number : "1.2-2"}} hours</div>
			}
			@if (asset.last_operation_date && !asset.is_fixed) {
				<div title="{{asset.last_operation_date | datetime}}">
					<b>Last operation:</b>
					<br />
					{{asset.last_operation_date | datetime : 'offsetshort' : time_offset_hours}}
				</div>
			}
		</div>
		<div class="ms-1">
			<app-health-right [item]="asset"></app-health-right>
		</div>
	</div>
</div>